import * as React from 'react';

import {colors} from 'shells/colors/colors';
// @ts-expect-error
import {CheckmarkIcon} from 'shells/icon/svg/checkmark-icon';
import {WarningIcon} from 'shells/icon/svg/warning-icon';
import type {IconStatusProps} from 'shells/icon-status/icon-status';
import type {SubdomainOption} from 'shells/subdomain-select/subdomain-select';

import type {FromDomainStatus} from 'nutshell-graphql-types';
import type {SubdomainFragment as Subdomain} from 'nutshell-graphql-types';

export const getDomainIconStatus = (
    emailDeliverabilityStatusVerified: boolean,
    hostingTrackingStatusVerified: boolean
): IconStatusProps => {
    if (emailDeliverabilityStatusVerified && hostingTrackingStatusVerified) {
        return {
            level: 'verified',
            text: 'Verified',
        };
    } else if (emailDeliverabilityStatusVerified || hostingTrackingStatusVerified) {
        return {
            level: 'pending',
            text: 'Partially configured',
        };
    }

    return {
        level: 'pending',
        text: 'Not set up',
    };
};

export const getIconInfoForRecord = (status: FromDomainStatus) => {
    const Icon = status === 'STATUS_VERIFIED' ? CheckmarkIcon : WarningIcon;
    const color = status === 'STATUS_VERIFIED' ? colors.green : colors.orangeAttention;

    return {Icon, color};
};

export const createSubdomainOptions = (subdomains: Subdomain[]): SubdomainOption[] => {
    return subdomains.map((subdomain) => createSubdomainOption(subdomain));
};

export const createSubdomainOption = (subdomain: Subdomain): SubdomainOption => {
    return {
        value: subdomain.fromDomainId,
        label: subdomain.record,
        customSublabel: getSubdomainOptionSublabel(subdomain.isVerified),
        isVerified: subdomain.isVerified,
    };
};

const getSubdomainOptionSublabel = (isVerified: boolean) => {
    // Verified state shows properly by default in the select
    if (isVerified) {
        return null;
    }

    return (
        <div className='flex align-center'>
            <WarningIcon
                size={15}
                // @ts-expect-error
                color={colors.orangeAttention}
                className='mr-8'
                alignCenter={true}
            />
            Not verified
        </div>
    );
};
